import { Box } from '@mui/material';
import { type ReactNode } from 'react';

import { type PanelAndContentPageBodyProps } from './PanelAndContentPage.js';
import { colors } from '../../../../theme';
import { STANDARD_LAYOUT_PADDING_X, STANDARD_LAYOUT_PADDING_Y } from '../../constants.js';
import { type PaddingVariant } from '../../types.js';

interface PanelProps extends Pick<PanelAndContentPageBodyProps, 'isPanelContainerWidthFixed'> {
  paddingVariant: PaddingVariant;
  children: ReactNode;
}

export function Panel(props: PanelProps) {
  const { paddingVariant, isPanelContainerWidthFixed, children } = props;

  return (
    <Box
      {...(paddingVariant === 'None'
        ? { padding: 0 }
        : { paddingX: STANDARD_LAYOUT_PADDING_X, paddingY: STANDARD_LAYOUT_PADDING_Y })}
      width={isPanelContainerWidthFixed ? '360px' : undefined}
      minWidth="360px"
      // Omitting top border to avoid double border with the parent container (Action Bar)
      borderRight={1}
      borderLeft={1}
      borderBottom={1}
      borderColor={colors.border.light}
      height="100%"
      sx={{
        overflowY: 'auto',
      }}
    >
      {children}
    </Box>
  );
}
